import React, { Component } from "react";
import { Form, Field } from "redux-form";

class PasswordResetForm extends Component {
  render() {
    const { error, handleSubmit } = this.props;

    return (
      <Form onSubmit={handleSubmit}>
        <div className="pb2 f4 font-bold">Réinitialiser votre mot de passe</div>

        {error && <div className="form__error">{error}</div>}
        <Field
          className="form__field form__field--medium"
          name="email"
          component="input"
          type="text"
          placeholder="e-mail"
        />
        <div className="tc mt3">
          <button className="button" type="submit">
            Réinitialiser <i className="i-arrow-right f7" />
          </button>
        </div>
      </Form>
    );
  }
}

export default PasswordResetForm;



// WEBPACK FOOTER //
// ./src/components/forms/PasswordResetForm.js